import { Navigate } from "react-router-dom";
import { useInactivityLogout } from "../hooks/useInactivityLogout";
import { getActiveAuth } from "../utils/authSession";

const ProtectedRoute = ({ children, userType, allowedRoles }) => {
  const identity = getActiveAuth();
  const userRole = identity?.role || "";
  const currentType = identity?.accountType === "admin"
    ? "user"
    : identity?.accountType === "professor"
    ? "professorId"
    : identity?.accountType === "student"
    ? "studentId"
    : null;

  useInactivityLogout(currentType === "user", "/AdminLogin", userRole);

  const allowed =
    Array.isArray(userType)
      ? userType.includes(currentType)
      : currentType === userType;

  if (!allowed) return <Navigate to="/LoginAs" replace />;
  if (
    currentType === "user" &&
    Array.isArray(allowedRoles) &&
    !allowedRoles.includes(userRole)
  ) {
    return <Navigate to="/CreateCourse" replace />;
  }

  return children;
};

export default ProtectedRoute;
